import RulesPage from './components/RulesPage';

const routes = [
  {
    path: '/rules',
    name: 'menu.rules',
    icon: 'calendar2-week',
    // customIcon: true,
    loginRequired: true,
    component: RulesPage,
    weight: 2,
    permission: [],
    children: [],
  },
];

export default routes;
